/* src/app/components/execution-sidebar/execution-sidebar.component.scss */
.sidebar-left {
  height: 100%;
  overflow-x: auto;
  border-left: 0.0625rem solid rgba(46, 46, 56, 0.08);
}
.sidebar-left .wrapper {
  padding: 3.75rem 4rem 2.5rem;
}
.sidebar-left .wrapper .pad {
  padding-bottom: 2.5rem;
}
.sidebar-left .wrapper .pad .owner {
  font-size: 0.625rem;
  line-height: 0.75rem;
  font-weight: 300;
  margin: 0;
  font-family: EYInterstate;
  color: rgba(114, 114, 127, 0.64);
  margin-left: 1rem;
}
.sidebar-left .wrapper .pad .nome {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  margin: 0;
  font-family: EYInterstate;
  color: #72727f;
  margin-left: 1rem;
}
.sidebar-left .content {
  padding: 0 4rem;
  margin-bottom: 2.5rem;
}
.sidebar-left .content .description {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  font-family: EYInterstate;
  color: rgba(46, 46, 56, 0.64);
  margin-bottom: 2rem;
}
.sidebar-left .content .sidebar-content {
  display: inline-flex;
  width: 100%;
  align-items: center;
}
.sidebar-left .content .sidebar-content .sidebar-icon {
  font-size: 1.375rem;
  line-height: 1.375rem;
  margin-right: 0.8125rem;
}
.sidebar-left .content .sidebar-content .sidebar-icon.ic-null {
  opacity: 0.64;
}
.sidebar-left .content .sidebar-content .sidebar-icon.ic-done {
  color: #168736;
}
.sidebar-left .content .sidebar-content .sidebar-icon.ic-failed {
  color: #89251c;
}
.sidebar-left .content .sub-tool-description {
  font-size: 1rem;
  line-height: 1.75rem;
  font-weight: 400;
  font-family: EYInterstate;
  color: #72727f;
  margin-right: 0.5rem;
}
.sidebar-left .description-extra-wrapper {
  padding: 0 2.5rem;
}
.sidebar-left .description-extra-wrapper .description-extra {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  color: #72727f;
}
.sidebar-left .description-extra-wrapper .description-extra .continue {
  font-weight: 400;
  color: rgba(46, 46, 56, 0.64);
}
.sidebar-left .loading-content {
  display: inline-flex;
  width: 100%;
  text-align: center;
}
.sidebar-left .loading-content .loading-tip {
  font-size: 1rem;
  line-height: 1.75rem;
  font-weight: 400;
  font-family: EYInterstate;
  color: rgba(46, 46, 56, 0.64);
  margin-bottom: 2rem;
  margin: auto;
}
/*# sourceMappingURL=execution-sidebar.component.css.map */
